import { Loader } from '@crossfit/ui'
import { useAuth } from 'components/Auth'
import IneligiblePage from 'pages/Ineligible'
import ReviewInvitePage from 'pages/TeamManagement/ReviewInvite'
import TermsOfService from 'components/TermsOfService'
import { useAffiliate } from 'hooks/useAffiliate'

export const AccessPortal = (
  element: JSX.Element,
  path: string,
): JSX.Element => {
  const { user } = useAuth()

  const {
    hasValidAgreement,
    canAccessDashboard,
    canAccessTeammates,
    canAccessProgramming,
    canAccessContentKit,
    canAccessPartnerNetwork,
    canAccessPlaybook,
    canAccessRoundtables,
    canAccessStarterKit,
    canAccessAdmin,
    canAccessAdminDirectoryPage,
    canAccessAdminContactInfoPage,
    canAccessAdminCoachesAndStaffPage,
    canAccessPricing,
  } = useAffiliate()

  if (!user) {
    return <Loader />
  }
  if (hasValidAgreement) {
    if (path.includes('dashboard')) {
      if (canAccessDashboard) {
        return element
      }
      return <IneligiblePage />
    }

    if (path.includes('affiliate-pricing')) {
      if (canAccessPricing) {
        return element
      }
      return <IneligiblePage />
    }

    if (path.includes('programming')) {
      if (canAccessProgramming) {
        return element
      }
      return <IneligiblePage />
    }

    if (path.includes('roundtables')) {
      if (canAccessRoundtables) {
        return element
      }
      return <IneligiblePage />
    }

    if (path.includes('playbook')) {
      if (canAccessPlaybook) {
        return element
      }
      return <IneligiblePage />
    }

    if (path.includes('partner-network')) {
      if (canAccessPartnerNetwork) {
        return element
      }
      return <IneligiblePage />
    }

    if (path.includes('marketing')) {
      if (canAccessContentKit) {
        return element
      }
      return <IneligiblePage />
    }

    if (path.includes('starter-kit')) {
      if (canAccessStarterKit) {
        return element
      }
      return <IneligiblePage />
    }

    if (path.includes('teammates')) {
      if (path.includes('teammates/review')) {
        return element
      }
      if (canAccessTeammates) {
        return element
      }
      return <IneligiblePage />
    }

    if (path.includes('admin')) {
      if (canAccessAdmin) {
        return element
      }
      return <IneligiblePage />
    }

    if (path.includes('directory-page')) {
      if (canAccessAdminDirectoryPage) {
        return element
      }

      return <IneligiblePage />
    }

    if (path.includes('contact-info')) {
      if (canAccessAdminContactInfoPage) {
        return element
      }

      return <IneligiblePage />
    }

    if (path.includes('staff')) {
      if (path.includes('staff/review')) {
        return element
      }
      if (canAccessAdminCoachesAndStaffPage) {
        return element
      }

      return <IneligiblePage />
    }
  }

  if (path.includes('staff/review')) {
    return <ReviewInvitePage />
  }

  return <TermsOfService />
}
